export type ShareMethod = 'copy_link' | 'email' | 'sms' | 'whatsapp' | 'native';

export type ShareContent = {
  title: string;
  text: string;
  url: string;
  emailSubject: string;
};

export const buildEmailUrl = ({ emailSubject, text, url }: ShareContent): string => {
  const body = `${text}\n\n${url}`;
  return `mailto:?subject=${encodeURIComponent(emailSubject)}&body=${encodeURIComponent(body)}`;
};

export const buildSmsUrl = ({ text, url }: ShareContent): string => {
  const body = `${text}\n${url}`;
  return `sms:?body=${encodeURIComponent(body)}`;
};

export const buildWhatsappUrl = ({ text, url }: ShareContent): string => {
  const message = `${text}\n${url}`;
  return `https://wa.me/?text=${encodeURIComponent(message)}`;
};

export const isMobileDevice = (): boolean => {
  if (typeof navigator === 'undefined') return false;
  return /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
};

export const isWebShareSupported = (): boolean => {
  return typeof navigator !== 'undefined' && typeof navigator.share === 'function';
};

// 데스크탑은 항상 모달, 모바일이면서 navigator.share 가능할 때만 네이티브 시트
export const shouldUseNativeShare = (): boolean => {
  return isMobileDevice() && isWebShareSupported();
};

// sms: 스킴이 동작하는 환경 — iOS/Android/macOS(Messages.app)
// 데스크탑 Windows/Linux 에서는 동작하지 않으므로 숨김
export const isSmsSupported = (): boolean => {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent;
  if (/Android|iPhone|iPad|iPod/i.test(ua)) return true;
  if (/Macintosh/i.test(ua)) return true;
  return false;
};
